import { isFeatureEnabled } from "./VelocityApi";
import { tryGetHostApi } from "./externalApi";
export async function SetStaticWidgetPinnedStatus(widgetDefinitionId, isPinned) {
    if (await isFeatureEnabled("Feature_XamlWidgetPicker")) {
        const widgetPickerApi = await tryGetHostApi("WidgetPicker", 2, 2);
        if (widgetPickerApi) {
            widgetPickerApi.UpdateStaticWidgetPinnedStateAsync(widgetDefinitionId, isPinned);
        }
    }
}
